<div class="recipe-card">
  <!-- Card Header -->
  <div class="card-header">
    <div class="recipe-number">
      <i class="fa-solid fa-book-open"></i>
      <span>#{{ index }}</span>
    </div>
    <span class="shared-badge" *ngIf="recipe?.isShared === true && recipe?.sharedFrom?.name"
      [title]="'Shared into ' + recipe?.sharedFrom?.name">
      <i class="fa-solid fa-share-nodes"></i>
      {{ recipe?.sharedFrom?.name }}
    </span>
    <div class="card-actions" *ngIf="showActions">
      <ng-content select="[card-actions]"></ng-content>
    </div>
  </div>

  <!-- Recipe Title -->
  <div class="card-content">
    <p class="recipe-text">{{ recipe?.memory }}</p>
  </div>

  <!-- Steps Section -->
  <div class="steps-section" *ngIf="steps.length > 0">
    <div class="steps-label">
      <i class="fa-solid fa-list-ol"></i>
      <span>{{ steps.length }} Steps</span>
    </div>
    <ol class="steps-list">
      <li class="step-item" *ngFor="let step of steps">
        <span class="step-marker">{{ step.order }}</span>
        <span class="step-text">{{ step.text }}</span>
      </li>
    </ol>
  </div>

  <!-- Keywords Section -->
  <div class="keywords-section" *ngIf="recipe?.tokens && recipe.tokens.length > 0">
    <div class="keywords-label">
      <i class="fa-solid fa-tags"></i>
      <span>Keywords</span>
    </div>
    <div class="keywords-list">
      <span class="keyword-chip" *ngFor="let token of recipe?.tokens">
        <i class="fa-solid fa-hashtag"></i>
        {{ token }}
      </span>
    </div>
  </div>

  <!-- Tag Section (notesKey) -->
  <div class="tag-section" *ngIf="recipe?.notesKey">
    <div class="tag-label">
      <i class="fa-solid fa-tag"></i>
      <span>Tag</span>
    </div>
    <span class="tag-badge">
      <i class="fa-solid fa-bookmark"></i>
      {{ recipe.notesKey }}
    </span>
  </div>

  <!-- Card Footer -->
  <div class="card-footer">
    <div class="metadata-item" *ngIf="recipe?.queryHash" [title]="'Hash: ' + recipe?.queryHash">
      <i class="fa-solid fa-fingerprint"></i>
      <span class="metadata-text">{{ recipe?.queryHash | slice:0:12 }}...</span>
    </div>
    <div class="metadata-item" *ngIf="recipe?.date" [title]="'Created: ' + recipe?.date">
      <i class="fa-solid fa-clock"></i>
      <span class="metadata-text">{{ recipe?.date }}</span>
    </div>
  </div>
</div>
